<div class="modal-content" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
    <div class="modal-body" *ngIf="isSuccess">
        <div class="d-flex justify-content-center align-items-center mt-2">
            <img src="assets/images/checkmark.png" alt="Account creation success" class="img-fluid " />
        </div>
        <h5 id="modalTitle" class="text-center text-black mt-3 mb-0" tabindex="-1" #modalTitle>Account Created</h5>
        <h5 class="text-center text-black ">Please Complete Registration</h5>
        <div role="status" aria-live="polite" aria-atomic="true" class="sr-only">Account created successfully. Please complete registration.</div>
        <p id="modalDescription" class="para-1 mt-3 text-center p-2 mb-0">Thank you for creating an account. A confirmation email has been
            sent to your registered email address.</p>
        <p class="para-1 mt-3 text-center p-2 mb-0">Please follow the instructions in that email to complete your
            registration.</p>
        <div class="mt-4 grey-box text-center p-2 mb-2">
            <p class="para-2 p-2 mb-0">If you provided a recovery email, a verification code has been sent there as
                well. If you do not see it in your inbox, check your Spam or Junk folder.</p>
          
        </div>
    </div>
    <div class="modal-body " *ngIf="!isSuccess">
        <h5 id="modalTitle" class="text-center mt-2" tabindex="-1" #modalTitle>Account May Already Exist</h5>
        <div role="status" aria-live="polite" aria-atomic="true" class="sr-only">Account may already exist. Please review the details.</div>
        <p id="modalDescription" class="para-1 p-2 mb-0 mt-3">An account with similar information appears to already exist. This may be duplicate registration. Please review the details below:</p>
        <div class="p-2">
        <p class="para-1 mb-1"><b>Name:</b> {{name}}</p>
        <p class="para-1 mb-1"><b>Email:</b> {{email}}</p>
        <p class="para-1 mb-1"><b>Phone:</b> {{phone}}</p>
        <p class="para-1 mb-1"><b>{{idType}}:</b> {{idValue}}</p>
        </div>
        <p class="para-1 p-2 mb-0">Please return to the form to review your information, or click Forgot Email to recover your account.</p>
    </div>
    <div class="d-flex btn-container justify-content-between" *ngIf="!isSuccess">
        <button type="button" class="btn btn-outline-secondary mr-2 w-50" (click)="modalClose()">Return to Form</button>
        <button type="button" class="btn btn-primary w-50" (click)="forgotEmail()" [disabled]="forgetEmailDisabled"><span *ngIf="forgetEmailDisabled"
        class="spinner-border spinner-border-sm" output="status" aria-hidden="true"></span>Forgot Email</button>
    </div>
</div>